import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

export function Terms() {
  return (
    <div className="p-6 max-w-3xl mx-auto space-y-6">
      <div className="flex items-center gap-3">
        <Link to="/">
          <Button variant="ghost" size="sm">
            <ArrowLeft className="mr-1 h-4 w-4" />
            Retour
          </Button>
        </Link>
        <h1 className="text-2xl font-bold text-slate-900">
          Conditions Generales d'Utilisation
        </h1>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="text-lg">Article 1 — Objet</CardTitle>
        </CardHeader>
        <CardContent className="prose prose-slate prose-sm max-w-none space-y-2">
          <p>
            Les presentes Conditions Generales d'Utilisation (CGU) regissent
            l'acces et l'utilisation de la plateforme MakeMyDoc, editee par
            Peerlab. MakeMyDoc est un outil SaaS d'aide a la redaction
            scientifique, de revues systematiques et de gestion de sources
            bibliographiques assistee par intelligence artificielle.
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle className="text-lg">Article 2 — Inscription et compte</CardTitle>
        </CardHeader>
        <CardContent className="prose prose-slate prose-sm max-w-none space-y-2">
          <p>
            L'utilisation de MakeMyDoc necessite la creation d'un compte.
            L'utilisateur s'engage a fournir des informations exactes et a
            maintenir la confidentialite de ses identifiants de connexion.
            Tout usage du compte est sous la responsabilite de l'utilisateur.
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle className="text-lg">Article 3 — Description du service</CardTitle>
        </CardHeader>
        <CardContent className="prose prose-slate prose-sm max-w-none space-y-2">
          <p>MakeMyDoc propose les fonctionnalites suivantes :</p>
          <ul className="space-y-1">
            <li>Import et gestion de sources bibliographiques (RIS, BIB).</li>
            <li>Screening automatise par IA avec signaux heuristiques et arbitrage LLM.</li>
            <li>Evaluation de sources selon des criteres personnalises.</li>
            <li>Chat avec les documents PDF.</li>
            <li>Revue collaborative multi-evaluateurs.</li>
            <li>Export de rapports PRISMA et extraction de donnees.</li>
          </ul>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle className="text-lg">Article 4 — Credits et paiements</CardTitle>
        </CardHeader>
        <CardContent className="prose prose-slate prose-sm max-w-none space-y-2">
          <p>
            Le service fonctionne sur un systeme de credits prepaye. Les
            credits sont consommes lors de l'utilisation de fonctionnalites
            d'IA (screening, evaluation, chat). Les achats de credits sont
            effectues via Stripe et ne sont pas remboursables, sauf
            disposition legale contraire.
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle className="text-lg">Article 5 — Propriete intellectuelle</CardTitle>
        </CardHeader>
        <CardContent className="prose prose-slate prose-sm max-w-none space-y-2">
          <p>
            L'utilisateur conserve la propriete integrale de ses donnees et
            contenus importes sur MakeMyDoc. Peerlab ne revendique aucun droit
            de propriete sur les sources, criteres, evaluations ou tout autre
            contenu genere par l'utilisateur.
          </p>
          <p>
            La plateforme MakeMyDoc, son code source, son interface et ses
            algorithmes sont la propriete exclusive de Peerlab.
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle className="text-lg">Article 6 — Responsabilite</CardTitle>
        </CardHeader>
        <CardContent className="prose prose-slate prose-sm max-w-none space-y-2">
          <p>
            Les evaluations et recommandations generees par l'IA sont
            fournies a titre indicatif et ne sauraient se substituer au
            jugement d'un chercheur qualifie. Peerlab ne garantit pas
            l'exactitude ni l'exhaustivite des resultats generes par l'IA.
          </p>
          <p>
            Peerlab s'efforce d'assurer la disponibilite du service mais ne
            peut garantir un acces ininterrompu. L'utilisateur est seul
            responsable de la sauvegarde de ses donnees.
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle className="text-lg">Article 7 — Protection des donnees</CardTitle>
        </CardHeader>
        <CardContent className="prose prose-slate prose-sm max-w-none space-y-2">
          <p>
            Le traitement des donnees personnelles est regi par notre{' '}
            <Link to="/privacy" className="text-indigo-600 hover:text-indigo-500 font-medium">
              Politique de Confidentialite
            </Link>.
            Peerlab s'engage a respecter le Reglement General sur la
            Protection des Donnees (RGPD).
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle className="text-lg">Article 8 — Suppression de compte</CardTitle>
        </CardHeader>
        <CardContent className="prose prose-slate prose-sm max-w-none space-y-2">
          <p>
            L'utilisateur peut supprimer son compte a tout moment depuis les
            parametres de son compte. La suppression entraine la suppression
            definitive et irreversible de l'ensemble des donnees associees
            (profil, sources, evaluations, criteres, historique de chat,
            credits restants).
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle className="text-lg">Article 9 — Modifications des CGU</CardTitle>
        </CardHeader>
        <CardContent className="prose prose-slate prose-sm max-w-none space-y-2">
          <p>
            Peerlab se reserve le droit de modifier les presentes CGU a tout
            moment. Les utilisateurs seront informes de toute modification
            substantielle par email. La poursuite de l'utilisation du service
            apres notification vaut acceptation des nouvelles conditions.
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle className="text-lg">Article 10 — Droit applicable</CardTitle>
        </CardHeader>
        <CardContent className="prose prose-slate prose-sm max-w-none space-y-2">
          <p>
            Les presentes CGU sont regies par le droit francais. En cas de
            litige, les tribunaux competents de Paris seront seuls competents.
          </p>
          <p>
            Contact : <strong>admin@peerlab.fr</strong>
          </p>
        </CardContent>
      </Card>

      <p className="text-xs text-slate-400 text-center pb-6">
        Derniere mise a jour : mars 2026
      </p>
    </div>
  );
}
